export default __webpack_public_path__ + "static/icon-rx-bottle-786e22ef8ab1f92c95770ce21d74dc71.png";